import api from '../api';

const getAuthHeaders = (token) => ({
  Authorization: `Bearer ${token}`
});

// Financial Case API functions
export const financialCaseApi = {
  // Lấy danh sách financial cases
  getFinancialCases: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases', {
        headers: getAuthHeaders(token),
        params
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting financial cases:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Lấy thông tin financial case theo ID
  getFinancialCaseById: async (token, caseId) => {
    try {
      const response = await api.get(`/financial-cases/${caseId}`, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting financial case by ID:', error);
      throw error;
    }
  },

  // Tạo financial case mới
  createFinancialCase: async (token, caseData) => {
    try {
      const response = await api.post('/financial-cases', caseData, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error creating financial case:', error);
      throw error;
    }
  },

  // Cập nhật financial case
  updateFinancialCase: async (token, caseId, caseData) => {
    try {
      const response = await api.put(`/financial-cases/${caseId}`, caseData, {
        headers: getAuthHeaders(token)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error updating financial case:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Xóa financial case
  deleteFinancialCase: async (token, caseId) => {
    try {
      const response = await api.delete(`/financial-cases/${caseId}`, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting financial case:', error);
      throw error;
    }
  },

  // Hủy financial case
  cancelFinancialCase: async (token, caseId) => {
    try {
      const response = await api.delete(`/financial-cases/${caseId}/cancel`, {
        headers: getAuthHeaders(token)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error canceling financial case:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Lấy thống kê financial cases
  getFinancialStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases/statistics/overview', {
        headers: getAuthHeaders(token),
        params
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting financial statistics:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  },

  // Lấy danh sách accountants cho dropdown
  getAccountants: async (token) => {
    try {
      const response = await api.get('/financial-cases/accountants', {
        headers: getAuthHeaders(token)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ [API ERROR] Error getting accountants:', error);
      console.error('❌ [API ERROR] Error response:', error.response);
      throw error;
    }
  }
}; 